import gql from 'graphql-tag';

export const ACKNOWLEDGE_ALERT = gql`
  mutation AcknowledgeAlertMutation($alertInput: AlertInput!) {
    acknowledgeAlert(alertInput: $alertInput) {
      alert {
        id
        notes
      }
      errors
    }
  }
`;
